// extracted by mini-css-extract-plugin
export default {"cardTextDownWrapper":"UI_ModuleTextDownCard_cardTextDownWrapper__Px5ry","cardTextDown":"UI_ModuleTextDownCard_cardTextDown__k9k+2"};